import { AppBar, Box, ITheme, Tab, Tabs, useTheme } from '@mui/material';
import React from 'react';
import logov2 from '../../assets/logov2.svg';
import SearchText from './SearchText';
import { AUTHENTICATED_ROUTES } from '../../resources/routes-constants';
import { Link, matchPath, useLocation } from 'react-router-dom';
import UserButton from './UserButton';
import { useTranslation } from 'react-i18next';
import Notifications from './Notifications';
import { useAppDispatch } from '../../store/reducers/store';
import { updateFilters } from '../../store/actions/libraryOfFunds';

function useRouteMatch(patterns: readonly string[]) {
    const { pathname } = useLocation();

    for (let i = 0; i < patterns.length; i += 1) {
        const pattern = patterns[i];
        const possibleMatch = matchPath(pattern, pathname);
        if (possibleMatch !== null) {
            return possibleMatch;
        }
    }

    return null;
}
const HeaderBar: React.FC = () => {
    const { t } = useTranslation();
    const theme = useTheme() as ITheme;
    const dispatch = useAppDispatch();

    const handleFilterClear = () => {
        dispatch(updateFilters({
            stage: [],
            sector: [],
            area: [],
            size: [],
            eltif: false,
            new: false,
            favorites: false,
            closingSoon: false,
            freeText: ""
        }));
    }

    const navItems = [
        { name: t("MnuDashboard"), description: t('A11yMnuDashboardDescription'), url: AUTHENTICATED_ROUTES.HOMEPAGE_ROUTE },
        { name: t("MnuPortfolios"), description: t('A11yMnuPortfoliosDescription'), url: AUTHENTICATED_ROUTES.PORTFOLIOS_ROUTE },
        { name: t("MnuLibraryOfFunds"), description: t('A11yMnuLibraryOfFundsDescription'), url: AUTHENTICATED_ROUTES.LIBRARYOFFUNDS_ROUTE, onClick: handleFilterClear }
    ];

    const routeMatch = useRouteMatch([AUTHENTICATED_ROUTES.HOMEPAGE_ROUTE, AUTHENTICATED_ROUTES.PORTFOLIOS_ROUTE + "/*", AUTHENTICATED_ROUTES.LIBRARYOFFUNDS_ROUTE + "/*"]);
    let currentTab = routeMatch?.pattern?.path;
    if (currentTab && currentTab.indexOf(AUTHENTICATED_ROUTES.PORTFOLIOS_ROUTE) !== -1) {
        currentTab = AUTHENTICATED_ROUTES.PORTFOLIOS_ROUTE;
    }
    if (currentTab && currentTab.indexOf(AUTHENTICATED_ROUTES.LIBRARYOFFUNDS_ROUTE) !== -1) {
        currentTab = AUTHENTICATED_ROUTES.LIBRARYOFFUNDS_ROUTE;
    }


    return <AppBar position="static" elevation={0} sx={{ zIndex: 1, backgroundColor: theme.palette.leo.header.background }}>
        <Box display={"flex"} justifyContent={"center"} height={"75px"} alignItems={"center"} gap={"115px"}>
            <Box display={"flex"} gap={"70px"}>
                <Link to={AUTHENTICATED_ROUTES.HOMEPAGE_ROUTE} aria-label={t('BtnGoHome')}><img src={logov2} width={"56px"} height={"29px"} alt={t('A11yMainLogoAlt')} /></Link>
                <SearchText />
            </Box>
            <Tabs value={currentTab} sx={{
                height: "100%",
                ".MuiTabs-flexContainer": {
                    height: "100%",
                    gap: "50px"
                },
                '& .MuiTabs-indicator': {
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: 'transparent',
                    height: "5px",
                },
                '& .MuiTabs-indicatorSpan': {
                    maxWidth: "84px",
                    width: '100%',
                    height: "5px",
                    borderRadius: "4px",
                    backgroundColor: theme.palette.primary.dark,
                }
            }} TabIndicatorProps={{
                children: <span className="MuiTabs-indicatorSpan" />

            }} aria-label='Navigation'>
                {navItems.map((item) => (
                    <Tab label={item.name} value={item.url} to={item.url} component={Link} aria-label={item.description} key={item.name} sx={{
                        textTransform: "initial",
                        fontWeight: "400",
                        color: theme.typography.body1.color,
                        "&.Mui-selected": {
                            color: theme.palette.primary.dark,
                            fontWeight: "600"
                        }
                    }} disableRipple 
                    onClick={item.onClick} />
                ))}
            </Tabs>
            <Box display={"flex"} gap={"30px"} alignItems={"center"}>
                <Notifications />
                <UserButton />
            </Box>
        </Box>
    </AppBar>
}

export default HeaderBar;